<template>
  <div>
    <div
      v-if="showChooseOptionMessage"
      class="text-md p-3 mt-2 bg-gray-10 text-center"
      v-html="bp('selectOption')"
    ></div>
    <div
      v-if="showEmptyStoreDataMessage"
      class="text-md p-3 mt-2 bg-gray-10 text-center"
      v-html="bp('notAvailableLocally')"
    ></div>
    <div id="lcly-button-0" :class="{hide: hideWidget}">
      <a id="lcly-link-0" href="https://brands.locally.com" target="_blank"></a>
    </div>
  </div>
</template>

<script>
import isEmpty from 'lodash/isEmpty';

export default {
  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
    product: {
      type: Object,
      default: () => ({}),
    },
    variant: {
      type: Object,
      default: () => ({}),
      required: true,
    },
    showLocallyWidget: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      storeData: {},
      showLink: true,
      hideWidget: true,
      showChooseOptionMessage: false,
    };
  },
  computed: {
    locallyConfig() {
      return {
        company_name: this.options.companyName,
        button_text: ':heart:',
        button_id: 'HTML',
        company_id: this.options.companyId,
        css: '6',
        color_0: '#999999',
        upc: this.productVariants,
        n_related_styles: '3',
        show_location_switcher: '1',
        show_location_prompt: '1',
        lang: this.$store.state.locale.toLowerCase().replace(/_/g, '-'),
        show_dealers: '1',
        n_dealers: '2',
        show_only_upc_stocking_dealers: '1',
        link_opens_modal: '1',
        show_address: '1',
        show_directions: '1',
        show_phone: '1',
        no_link: '0',
        hide_all_when_no_stock: '0',
      };
    },
    isVariantSelected() {
      return !isEmpty(this.variant);
    },
    locallyEndpoint() {
      const obj = this.locallyConfig;
      const locallyQuery = Object.keys(obj)
        .reduce((a, k) => {
          a.push(`${encodeURIComponent(k)}=${encodeURIComponent(obj[k])}`);
          return a;
        }, [])
        .join('&');
      return `${this.options.baseUrl}/stores/map.js?${locallyQuery}`;
    },
    showEmptyStoreDataMessage() {
      const storeText = document.getElementsByClassName('lcly-no-stock');
      const changeLocationText = document.getElementById('lcly-location-prompt-0');
      return (
        (isEmpty(this.storeData) && !storeText.length && this.isVariantSelected && changeLocationText) ||
        (this.storeData.n_items_stocking_product === 0 &&
          !storeText.length &&
          this.isVariantSelected &&
          changeLocationText)
      );
    },
    productVariants() {
      return this.product.variants.map((variant) => variant.upc).toString();
    },
  },
  watch: {
    variant: function() {
      if (this.isVariantSelected) {
        this.locallyConfig.upc = this.variant.upc;
        this.locallyConfig.no_link = '0';
        window.lcly_reload_0({upc: this.variant.upc});
      }
    },
    showLink: function() {
      window.lcly_reload_0({
        hide_all_when_no_stock: this.locallyConfig.hide_all_when_no_stock,
        no_link: this.locallyConfig.no_link,
        upc: this.variant.upc ? this.variant.upc : '',
      });
    },
    showLocallyWidget: function() {
      window.lcly_reload_0({
        hide_all_when_no_stock: this.locallyConfig.hide_all_when_no_stock,
        no_link: this.locallyConfig.no_link,
        upc: this.variant.upc ? this.variant.upc : '',
      });
    },
  },
  mounted() {
    this.setUpLocallyRadius();
    this.appendLocallyScript();
  },
  destroyed: function() {
    this.locallyData();
  },
  methods: {
    appendLocallyScript() {
      const script = document.createElement('script');
      script.src = this.locallyEndpoint;
      script.id = 'lcly-script-0';
      script.async = true;
      document.head.appendChild(script);
      this.locallyData();
    },
    locallyData() {
      window.addEventListener('LOCALLY_data_update', this.storeDataLoad, false);
    },
    storeDataLoad(event) {
      this.storeData = event.detail;
      if (!this.isVariantSelected) {
        this.hideWidget = true;
        if (!this.storeData.product_id) {
          this.locallyConfig.hide_all_when_no_stock = '1';
          this.showChooseOptionMessage = false;
          this.$emit('change-locally-widget', false);
        } else {
          this.showChooseOptionMessage = true;
        }
      } else {
        this.showChooseOptionMessage = false;
        if (isEmpty(this.storeData) || (this.storeData.n_items_stocking_product === 0 && this.storeData.product_id)) {
          this.hideWidget = false;
          this.locallyConfig.no_link = '0';
          this.locallyConfig.hide_all_when_no_stock = '0';
          this.showLink = false;
          this.$emit('change-locally-widget', true);
        } else if (!this.storeData.product_id) {
          this.locallyConfig.hide_all_when_no_stock = '1';
          this.$emit('change-locally-widget', false);
        } else {
          this.locallyConfig.no_link = '0';
          this.locallyConfig.hide_all_when_no_stock = '0';
          this.hideWidget = false;
          this.showLink = true;
          this.$emit('change-locally-widget', true);
        }
      }
    },
    setUpLocallyRadius() {
      const kmLocales = ['en_ca', 'fr_ca'];
      if (kmLocales.includes(this.$store.state.locale.toLowerCase())) {
        this.locallyConfig.radius_in_km = '200';
      } else {
        this.locallyConfig.radius_in_miles = '200';
      }
    },
  },
};
</script>
